/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENTS_TAB = "ALL_COMMENTS" | "FEATURED_COMMENTS" | "NONE" | "QUESTIONS" | "REVIEWS" | "UNANSWERED_COMMENTS" | "%future added value";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type AnsweredCommentsContainerLocal = {
    readonly commentsOrderBy: COMMENT_SORT;
    readonly commentsTab: COMMENTS_TAB;
    readonly " $refType": "AnsweredCommentsContainerLocal";
};
export type AnsweredCommentsContainerLocal$data = AnsweredCommentsContainerLocal;
export type AnsweredCommentsContainerLocal$key = {
    readonly " $data"?: AnsweredCommentsContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"AnsweredCommentsContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AnsweredCommentsContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentsOrderBy",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentsTab",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '90172f8d36e411cd8ebde74977c3eacf';
export default node;
